import React from 'react';
import Tailan from './Journal';

const PageList = () => <Tailan />;

export default PageList;
